/* eslint-disable no-plusplus */
import {
  nonEditable,
  textCell,
  headerCell
} from "../cells";
import { HEADER_ROW_ID, ROW_HEIGHT } from "../constants";
import { formatCurrency } from "@/utils/helpers";

export const CASH_IN_CHANGE_ROW_ID = "cashInChange";

function getHeaderRow(columns) {
  return {
    rowId: HEADER_ROW_ID,
    height: ROW_HEIGHT,
    cells: columns.map((column) => headerCell(column.label)),
  };
}

function getGroupRows(title, groups, totalDebit, totalCredit, columns, groupIndex, formattedTotals) {
  console.log("formattedTotals",formattedTotals)
  if (groups?.length) {
    return [
      ...groups.map((item, index) => ({
        rowId: item.id,
        height: ROW_HEIGHT,
        cells: columns.map((column) => {
          let className = "";
          const textCellArgs = {};

          if (column.formatter) {
            textCellArgs.text = column.formatter(item[column.columnId], index);
          } else {
            textCellArgs.text = item[column.columnId] ?? "";
          }

          if (column.classname) {
            className = column.classname(item);
          }

          return nonEditable(textCell(textCellArgs), className);
        }),
      })),
      {
        rowId: `${title}-${groupIndex}-Footer`,
        height: ROW_HEIGHT,
        cells: columns.map((column, i) => {
          const hasDebits = columns.some((col) => col.columnId === "debits");
          const hasCredits = columns.some((col) => col.columnId === "credits");
          if (column.columnId === "openingBalance") {
            return headerCell(`${formattedTotals?.openingBalance}` || 0, "font-bold total-row-credit"); 
          }
          if (column.columnId === "closingBalance") {
            return headerCell(`${formattedTotals?.closingBalance}` || 0, "font-bold total-row-debit"); 
          }
          if (column.columnId === "netActivity") {
            return headerCell(`${formattedTotals?.netActivity}` || 0, "font-bold total-row-credit");
          }
          if (column.columnId === "debits") {
            return headerCell(`${formattedTotals?.debits}` || 0, "font-bold total-row-debit");
          } if (column.columnId === "credits") {
            return headerCell(`${formattedTotals?.credits}` || 0, "font-bold total-row-credit");
          } if ((hasDebits || hasCredits) && i === 0) {
            return headerCell(title, "font-bold total-row");
          }
          if (!hasDebits && !hasCredits) {
            return headerCell("", "");
          }
          return headerCell("", "total-row");
        })
      },
    ];
  }
  return [];
}

export function getTrialBalanceRows({
  data,
  columns
}) {
  if (!data) {
    return [];
  }

  const totals = data.data.reduce((acc, item) => {
    return {
      closingBalance: (acc.closingBalance || 0) + (parseFloat(item.closingBalance) || 0),
      netActivity: (acc.netActivity || 0) + (parseFloat(item.netActivity) || 0),
      openingBalance: (acc.openingBalance || 0) + (parseFloat(item.openingBalance) || 0),
      credits: (acc.credits || 0) + (parseFloat(item.credits) || 0),
      debits: (acc.debits || 0) + (parseFloat(item.debits) || 0)
    };
  }, {});

  const formattedTotals = {
    closingBalance: formatCurrency(totals.closingBalance, "AED"),
    netActivity: formatCurrency(totals.netActivity, "AED"),
    openingBalance: formatCurrency(totals.openingBalance, "AED"),
    credits: formatCurrency(totals.credits, "AED"),
    debits: formatCurrency(totals.debits, "AED")
  };
  return [
    getHeaderRow(columns), 
    ...getGroupRows(
      "Total", 
      data.data, 
      formatCurrency(data?.totalDebits, "AED"), 
      formatCurrency(data?.totalCredits, "AED"), 
      columns,
      undefined,
      formattedTotals // Pass the formatted totals to use in the footer row
    )
  ];
}
